import { useRef, useLayoutEffect, useState } from 'react';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

interface BaseSelectDateProps {
  id: number | string;
  field: string;
  value: any;
  onChange: (id: number | string, field: string, value: any) => void;
}

const BaseSelectDate = ({
  id,
  field,
  value,
  onChange,
}: BaseSelectDateProps) => {
  const textFieldRef = useRef<HTMLInputElement | null>(null);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleChange = (newValue: Date | null) => {
    onChange(id, field, newValue);
  };

  useLayoutEffect(() => {
    if (textFieldRef.current) {
      setAnchorEl(textFieldRef.current.parentElement);
    }
  }, []);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DesktopDatePicker
        value={value ? new Date(value) : null}
        onChange={handleChange}
        format="MM/dd/yyyy"
        slotProps={{
          popper: {
            disablePortal: false,
            placement: 'bottom-start',
            anchorEl,
            sx: {
              zIndex: 1300,
            },
          },
          textField: {
            inputRef: textFieldRef,
            fullWidth: true,
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default BaseSelectDate;
